import { h, Fragment, render } from "preact";
import { useState, useEffect, useRef } from "preact/hooks";
import axios from "axios";
import { Card, Typography, Button, Input, Select, Table } from "antd";
import { serviceMap } from "../../../Transactions/TransactionsUtils";
import useWebhooks from "./useWebhooks";
import './WebhooksTab.css'
import { Tooltip } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import { CopyOutlined } from "@ant-design/icons";
import WebhookDatasource from "./WebhooksDatasource";

export default function WebhooksTab(props){
    const {webhooks, fetchWebhooks, isLoading, updateWebhooks, deleteWebhook} = useWebhooks();
    const [service, setService] = useState('');
    const [target_url, setTarget_url] = useState('');
    const datasource = WebhookDatasource().asTableView()
    
    const onButtonClick = async(event) => {
      let inputData = {service, target_url}
      clearInput();
      updateWebhooks(inputData).then(()=>{
        fetchWebhooks();
      })
    }
    
    const handleSelect = (service) =>{
      setService(service); 
    }

    const handleDelete = async(index) =>{
      await deleteWebhook(index);
      await fetchWebhooks();
  }

    const handleURL = (e) =>{
      setTarget_url(e.target.value);
    }

    const clearInput = () =>{
      setTarget_url('')
      setService('')
    }

    const onTooltipClick = (value) => navigator.clipboard.writeText(value);

    const extractSelectOption = () => {
      const serviceArray = Array.from(serviceMap, ([value, label]) => ({ value, label }));
      return (<Select
          value={service}
          onChange={handleSelect}
          placeholder={"Select a service"}
            style={{
              width: "100%"
            }}
        >
        {...serviceArray.map(service =>{
          return <Select.Option value={service.value}>{service.label === 'Document Recognition' ? `${service.label} (${service.value})` : service.label}</Select.Option>
        })}
      </Select>)

    }

    useEffect(()=>{
      fetchWebhooks();
    }, [])


     
      const table = {
      columns: [
          {
              title: datasource.columns[0].title,
              dataIndex: datasource.columns[0].dataIndex,
              render: (service_name, index)=>(
              
              <Typography.Text>
                  {service_name}
              </Typography.Text>
              ),
              width: "30%",
          },
          {
              title: "URL",
              dataIndex: "target_url",
              render: (target_url, index)=>(
              <Typography.Text>
              {
                  <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                  }}>
                      <div>{target_url}</div>
                      <div style={{
                          display: "flex",
                          columnGap: "5px",
                      }}>
                      <Tooltip title="Copy">
                          <CopyOutlined
                              onClick={(event) => onTooltipClick(target_url)}
                              style={{ color: 'black', fontSize: "16px" }}
                          />
                      </Tooltip>
                      <Tooltip title="Delete">
                          <DeleteOutlined
                              onClick={(event) => handleDelete(index)}
                              style={{ color: 'black' , fontSize: "16px"}}
                          />
                      </Tooltip>
                      </div>
                  </div>
          }
              </Typography.Text>
              )
          }
      ],
      rows:
          datasource.rows,
      };
    
    return (
          <div className="webhook-page">
              <div className="webhook-container">
                <div
                 className="webhook-form"
                >
                  <Typography.Title level={3}>
                    My Webhooks
                  </Typography.Title>
                  <div>
                    <Typography.Title level={5}>
                      Service Name
                    </Typography.Title>
                   {extractSelectOption()}
                  </div>
                  <div>
                    <Typography.Title level={5}>
                      URL
                    </Typography.Title>
                    <Input
                    onChange={handleURL} 
                    value={target_url}
                    placeholder="https://example.com/webhook"
                    />
                  </div>
                  <div className="button-container">
                  <Button
                        onClick={onButtonClick}
                        type="primary"
                        style={{marginTop: "16px" }}
                        disabled = {service === '' || target_url === ''}
                      >
                  Add Webhook
                </Button>
                </div>
                </div>
                <div
                  className="webhook-info"
                >
                  <Typography.Title level={3}>Webhooks</Typography.Title>
                  <Typography.Text> A webhook is an HTTP-based callback function that allows
                    lightweight, event-driven communication between 2
                    application programming interfaces (APIs).
                  </Typography.Text>
                </div>
              </div>
              <div>
                <Table className="webhooks-table"
                       dataSource={[...webhooks]}
                       columns={table.columns}
                       pagination={false}
                       loading={isLoading}
                       />
              </div>
            </div>
            );
}